import { dataLoader } from '../utilities/dataLoader';

export const loadedData = dataLoader('class-data-loader');
